import { useContext } from 'react';
import { createContext } from 'react';

import { DrawerHeaderProps } from '../@types/DrawerHeaderProps';

export const DrawerHeaderContext = createContext<DrawerHeaderProps>({} as DrawerHeaderProps);

DrawerHeaderContext.displayName = 'DrawerHeader';

const DrawerHeaderProvider = (props: DrawerHeaderProps) => (
	<DrawerHeaderContext.Provider value={props}>{props.children}</DrawerHeaderContext.Provider>
);

export const useDrawerHeader = () => {
	const context = useContext(DrawerHeaderContext);

	return context;
};

export default DrawerHeaderProvider;
